export const wtbProductInterestData = {
    HandheldPlasmaCuttingSystems: {
        ht_technologyinterest: "206380000",
        ht_platform: "206380000",
        ht_productclasstype: "692300003",
        ht_materialshape: "",
        ht_application: "",
        ht_productmodelline: ""
    },
    AutomatedPlasmaCuttingSystems: {
        ht_technologyinterest: "206380000",
        ht_platform: "206380000",
        ht_productclasstype: "692300003",
        ht_materialshape: "",
        ht_application: "",
        ht_productmodelline: ""
    },
    PlasmaConsumables: {
        ht_technologyinterest: "206380000",
        ht_platform: "",
        ht_productclasstype: "692300002",
        ht_materialshape: "",
        ht_application: "",
        ht_productmodelline: ""
    },
    LaserConsumables: {
        ht_technologyinterest: "206380001",
        ht_platform: "",
        ht_productclasstype: "692300011",
        ht_materialshape: "",
        ht_application: "",
        ht_productmodelline: ""
    }
};